export const calculatePageText = {
    pageLabel: '병원 검사 정산',
    pageTitle: '병원 검사 정산',
    countDiagnosis: '건의 진료',
};
